export default "__VITE_ASSET__BvBXW4FN__"